@import (reference) '~ss-ui-client/src/constants/spacing.module.less';

.content {
  padding: @space-0 @space-16 @space-16;
}

.container {
  width: 100%;
}

.divider {
  height: unset;
  border-color: var(--grey-300);
}

.cell {
  flex: 1;
}
